import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export function renderChart(mapOptions, mapDataFromProps) {
    return (
        <React.Fragment>
        {Object.keys(mapDataFromProps).length > 0 ? (
            <HighchartsReact
            highcharts={Highcharts}
            options={mapOptions}
            allowChartUpdate={true}
            immutable={false}
            updateArgs={[true, true, true]}
            />
        ) : (
            <HighchartsReact highcharts={Highcharts} options={mapOptions} />
        )}
        </React.Fragment>
    );
}

export function calculateCategoryPercentageRoundedToOneDecimalPlace(categoryCount, totalCount) {
    let rawCategoryPercentage = (categoryCount / totalCount) * 100;
    let categoryPercentageRoundedToOneDecimalPlace = Math.round(rawCategoryPercentage * 10) / 10;
    return categoryPercentageRoundedToOneDecimalPlace;
}


// WEBPACK FOOTER //
// ./src/features/shared-components/chart/CommonChartMethods.js